const KIOSK_LOCK_KEY = 'kioskLock';
const KIOSK_UNLOCK_KEY = 'kioskUnlocked';

export const enableKioskLock = () => {
  sessionStorage.setItem(KIOSK_LOCK_KEY, '1');
};

export const disableKioskLock = () => {
  sessionStorage.removeItem(KIOSK_LOCK_KEY);
};

export const isKioskLockActive = () => sessionStorage.getItem(KIOSK_LOCK_KEY) === '1';

export const setKioskUnlocked = () => {
  sessionStorage.setItem(KIOSK_UNLOCK_KEY, '1');
};

export const clearKioskUnlocked = () => {
  sessionStorage.removeItem(KIOSK_UNLOCK_KEY);
};

export const isKioskUnlocked = () => sessionStorage.getItem(KIOSK_UNLOCK_KEY) === '1';

/** Cierra sesión de terminal por completo (salir). */
export const endKioskSession = () => {
  disableKioskLock();
  clearKioskUnlocked();
};
